import { Membership, PurchaseRule, PurchaseRuleLink } from "types";
import { useResource } from "@/hooks/useResource";

export const useMembershipRedemptionRule = (membership: Membership) => {
    const { data: redemptionPurchaseRuleLink, isFetching } = useResource<PurchaseRuleLink>(
        ["purchaseRuleLinks", membership?.redemptionPurchaseRuleLink?.id],
        { expand: "purchaseRule" },
    );

    return {
        data: redemptionPurchaseRuleLink?.purchaseRules[0]?.purchaseRule as PurchaseRule,
        isFetching,
    };
};
